<template>
  <v-btn color="default" @click="getCode()"
    >Получить код
    <v-progress-circular
      v-if="loading"
      class="ml-1"
      indeterminate
      size="18"
    ></v-progress-circular>
  </v-btn>
</template>

<script>
import api from "../api";
import store from "../store";
import axios from "axios";

export default {
  name: "get-code",
  props: ["email"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    getCode() {
      this.loading = true;

      axios
        .post(api.code, {
          email: this.email
        })
        .then(resp => {
          store.snackbar = true;
          store.snackbarSuccess = true;
          store.snackbarMessage = "Код отправлен на почту";
          this.$emit("code-sent", { id: Number(resp.data.id) });
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
